import { PrivacyPolicyModule } from './components/pages/privacy-policy/privacy-policy.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthModule, AuthHttpInterceptor } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { ServicesModule } from './services/services.module';
import { SharedModule } from './components/shared/shared.module';
import { HelpComponent } from './components/pages/help/help.component';
import { TermsOfUseModule } from './components/pages/terms-of-use/terms-of-use.module';
import { DisclosureModule } from './components/pages/disclosure/disclosure.module';
import { PrimeNGModule } from './components/shared/prime-ng.module';
import { MaskNumberPipe } from './components/shared/pipes/mask-number.pipe';
import { MsClarityComponent } from './components/pages/ms-clarity/ms-clarity.component';
import { HotJarComponent } from './components/pages/hot-jar/hot-jar.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { ApiErrorComponent } from './components/pages/api-error/api-error.component';
import { SessionTimeoutComponent } from './components/pages/session-timeout/session-timeout.component';
import { ContactCinchComponent } from './components/pages/contact-cinch/contact-cinch.component';
import { SpecialMemberOfferComponent } from './components/pages/special-member-offer/special-member-offer.component';
import { SpecialMemberOfferV2Component } from './components/pages/special-member-offer-v2/special-member-offer-v2.component';
import { SpecialMemberOfferFormComponent } from './components/pages/special-member-offer-form/special-member-offer-form.component';
import { EnrollReviewComponent } from './components/pages/special-member-offer-v2/enroll-review/enroll-review.component';
import { EnrollSuccessComponent } from './components/pages/special-member-offer-v2/enroll-success/enroll-success.component';

@NgModule({
  declarations: [
    AppComponent,
    HelpComponent,
    MsClarityComponent,
    HotJarComponent,
    NotFoundComponent,
    ApiErrorComponent,
    SessionTimeoutComponent,
    ContactCinchComponent,
    SpecialMemberOfferComponent,
    SpecialMemberOfferV2Component,
    SpecialMemberOfferFormComponent,
    EnrollReviewComponent,
    EnrollSuccessComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule.forRoot({
      domain: environment.domain,
      clientId: environment.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        prompt: 'none',
      },
      useRefreshTokens: true,
      // Specify configuration for the interceptor
      httpInterceptor: {
        allowedList: [
          // Attach access tokens to any calls that start with '/api/'
          { uri: '/api/*', allowAnonymous: true },
          { uri: 'api/*', allowAnonymous: true },
          { uri: '/services/*', allowAnonymous: true },
          { uri: 'services/*', allowAnonymous: true },
        ],
      },
    }),
    BrowserAnimationsModule,
    AppRoutingModule,
    ServicesModule.forRoot(),
    SharedModule,
    TermsOfUseModule,
    DisclosureModule,
    PrivacyPolicyModule,
    PrimeNGModule
  ],
  providers: [
    provideAnimationsAsync(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    MaskNumberPipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
